<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Multiple select-->
        <div class="box">
          <div class="box-header with-border">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>系统管理</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/department/departmentList' }">学校列表</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="box-body" style="min-height:80%;">
            <div class="search-div">
              <el-input v-model="sn" placeholder="学校序号" class="input-size-200 input-margin-right" clearable></el-input>
              <el-input v-model="name" placeholder="学校名称" class="input-size-200 input-margin-right" clearable></el-input>
              <el-input v-model="updatedUserName" placeholder="录入人" class="input-size-200 input-margin-right" clearable></el-input>
              <el-button type="primary" icon="el-icon-search" class="button-pull-right" @click="search()">搜索</el-button>
              <el-button type="success" icon="el-icon-plus" class="button-pull-right" style="margin-right: 20px" @click="handleCreate()">新增</el-button>
              <br/>
            </div>
            <el-table
              ref="multipleTable"
              :data="dt.data"
              :stripe="true"
              border
              highlight-current-row
              style="width: 100%"
              :size="dt.size"
              :cell-style="{fontFamily: '宋体', fontSize: '16px'}"
              @sort-change="dt.handleSortChange"
              @selection-change="dt.handleSelectionChange">
<!--              <el-table-column-->
<!--                type="selection"-->
<!--                fixed-->
<!--                width="50px">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                property="id"-->
<!--                label="ID"-->
<!--                fixed-->
<!--                width="100px">-->
<!--              </el-table-column>-->
              <el-table-column
                property="sn"
                label="序号"
                class-name="money"
                sortable="custom"
                width="100px">
              </el-table-column>
              <el-table-column
                property="name"
                label="名称"
                class-name="money"
                sortable="custom">
              </el-table-column>
<!--              <el-table-column-->
<!--                property="phone"-->
<!--                label="手机"-->
<!--                width="100px"-->
<!--                sortable="custom"-->
<!--                show-overflow-tooltip>-->
<!--              </el-table-column>-->
              <el-table-column
                property="updatedUserName"
                label="录入人"
                width="100px"
                sortable="custom"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="createdAt"
                label="创建时间"
                width="110px"
                :formatter="dateFormat"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="updatedAt"
                label="修改时间"
                width="110px"
                :formatter="dateFormat"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="操作" width="160px" fixed="right" class-name="money">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    @click="handleUpdate(scope.$index, scope.row)">编辑
                  </el-button>
                  <el-button
                    size="small"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="dt.handleSizeChange"
              @current-change="dt.handleCurrentChange"
              :current-page="dt.currentPage"
              :page-sizes="dt.pageSizes"
              :page-size="dt.pageSize"
              :layout="dt.layout"
              :total="dt.totalElements">
            </el-pagination>
          </div>
        </div>

        <!-- 编辑弹窗 -->
        <el-dialog title="学校" :visible.sync="dialogFormVisible" width="40%">
          <el-form ref="form" :model="vo" label-width="100px">
            <el-form-item label="序号" prop="sn" :rules="[{required: true, message: '请输入', trigger: 'blur'}]">
              <el-input v-model="vo.sn"></el-input>
            </el-form-item>
            <el-form-item label="名称" prop="name" :rules="[{required: true, message: '请输入', trigger: 'blur'}, {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'}]">
              <el-input v-model="vo.name"></el-input>
            </el-form-item>
            <div style="width: 100%; text-align: center">
              <el-button type="primary" @click="onSubmit('form')">确定</el-button>
              <el-button @click="dialogFormVisible = false">取消</el-button>
            </div>
          </el-form>
        </el-dialog>
        <!-- 编辑弹窗 END -->
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
  import {DataTable} from "../../../data-table";

  export default {
    name: 'Departmentist',
    data: function () {
      let that = this;
      return {
        //  表格设置
        extnedsParms: {},
        dt: DataTable.getInstance(that, '/admin/department/findPage', null, null),
        sn: null,
        name: '',
        updatedUserName: '',
        vo: {},
        dialogFormVisible: false
      }
    },

    mounted: function () {
      // 清理旧的绑定属性
      this.dt.cleanBindFields();
      // 绑定过滤属性
      this.dt.bindNumberField("sn", "sn");
      this.dt.bindStringField("name", "name");
      this.dt.bindStringField("updatedUserName", "updatedUserName");
      // 还原之前查询条件到Vue属性
      this.dt.bindFieldToVueProp();
      //  向后台查询数据
      this.dt.queryPageData()
    },

    methods: {
      dateFormat: function (row, column) {
        var date = row[column.property];
        if (date === undefined || date === null) {
          return "";
        }
        return this.$moment(date).format("YYYY-MM-DD");
      },
      // 搜索
      search: function () {
        // 更新最新的查询条件
        this.dt.bindFieldToFilter();
        this.dt.queryPageData()
      },
      //  创建新记录
      handleCreate: function () {
        this.vo = {name: ""};
        this.dialogFormVisible = true;
      },
      //  编辑记录
      handleUpdate: function (idx, model) {
        let obj = {};
        Object.assign(obj, model);
        this.vo = obj;
        this.dialogFormVisible = true;
      },
      onSubmit: function (formName) {
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.axios.post('admin/department/save', that.vo)
              .then(resp => { // 保存成功跳回列表页面
                if (resp.data && resp.data.code === 200) {
                  this.$message({
                    type: 'success',
                    message: '处理成功!'
                  })
                  this.dialogFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    type: 'success',
                    message: '处理失败!' + resp.data.message
                  })
                }
              }).catch(resp => {
              this.$message({
                type: 'error',
                message: "请求服务器出错"
              })
            })
          } else {
            return false;
          }
        });
      },
      // 删除
      handleDelete: function (index, row) {
        this.$confirm('此操作将删除该学校, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              instance.confirmButtonText = '执行中...'
              setTimeout(() => {
                this.axios.post('/admin/department/delete', [], {params: {id: row.id}})
                  .then(resp => { // 保存成功跳回列表页面
                    if (resp.data.code === 200) {
                      done()
                      this.dt.queryPageData()
                      this.$message({
                        type: 'success',
                        message: '刪除成功'
                      })
                    } else {
                      done()
                      this.$message({
                        type: 'error',
                        message: '刪除失敗'
                      })
                    }
                  }).catch(resp => {
                  done()
                  this.$message({
                    type: 'error',
                    message: '刪除失敗'
                  })
                })
                setTimeout(() => {
                  instance.confirmButtonLoading = false
                }, 300)
              }, 1000)
            } else {
              done()
            }
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    }
  }
</script>
<style type="scss">
.money {
  font-family: '宋体';
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// DepartmentList.vue?fdea0dc2